"use strict";

export default ($axios, store) => ({
  list() {
    return $axios.$get("/daisuke/applicationtypes");
  },
  get(id) {
    return $axios.$get(`/daisuke/applicationtypes/${id}`);
  },
  remove(id) {
    return $axios.$delete(`/daisuke/applicationtypes/${id}`);
  },
  create(type) {
    return $axios.$post("/daisuke/applicationtypes", type);
  },
  update(id, type) {
    return $axios.$put(`/daisuke/applicationtypes/${id}`, type);
  },
});
